import { render } from "./PosComprobantes.vue?vue&type=template&id=266b93e9&scoped=true"
import script from "./PosComprobantes.vue?vue&type=script&lang=js"
export * from "./PosComprobantes.vue?vue&type=script&lang=js"

import "./PosComprobantes.vue?vue&type=style&index=0&id=266b93e9&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266b93e9"]])

export default __exports__